import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { EnrollmentType } from '../../components/enums/enrollment-type';
import { PlanType } from '../../components/enums/plan-type';
import FormInput from '../../components/form_elements/form-input';
import FormRadio from '../../components/form_elements/form-radio';
import ContributionInfo from './contribution-info';
import { getWeeklyFsaAmount, getYearlyFsaAmount } from '../../components/fsa-calculator';

const FsaDependent = ({title, details, payPeriodsUntilEffectiveDate, remainingPayChecksThisYear, contributionPeriodName, coverageTypeName, yearlyAmountName, weeklyAmountName, planType,reset, enabled}) => {
     const [options, setOptions] = useState([]);
     const {watch, setValue, trigger} = useFormContext();
     const enrollments = useSelector(s => s.enrollments);
     const coverageType = watch(coverageTypeName);

     useEffect(() => {
          let options = [
               {
                 id: 3,
                 name: "Waive Coverage"
               },
               {
                   id: 2,
                   name: "Select a fixed amount"
               },
   
           ]
           if(enrollments.enrollmentTypeId === EnrollmentType.OpenEnrollment){
             options = options.filter(o => o.id !== 1);
           }
         setOptions(options);

         const selection = enrollments.selections?.find(s => s.planType === planType);
         if(selection?.amount){
          setValue("agreement", true);
          }


         if(selection?.amount !== null && selection?.amount !== undefined) {
          
              if(selection?.amount === 0 ){
               setValue(coverageTypeName, 3);
              } else {
               setValue(coverageTypeName, 2);
               setValue(weeklyAmountName, selection?.amount);
               setYearly(selection?.amount);
              }
         } else {
               if(enrollments.enrollmentTypeId !== EnrollmentType.NewHire){
                    setValue(coverageTypeName, 3);
               }
         }
     }, [enrollments, reset]);

     const setWeekly = (e) => {
          let amount = getWeeklyFsaAmount(e, remainingPayChecksThisYear, details.yearToDateContributionAmount, details.currentWeeklyContributions, payPeriodsUntilEffectiveDate, details.myWeeklyMax)
          setValue(weeklyAmountName, amount)
          trigger(weeklyAmountName);
     }

     const setYearly = (e) => {
          let amount = getYearlyFsaAmount(e, remainingPayChecksThisYear, details.yearToDateContributionAmount, details.currentWeeklyContributions, payPeriodsUntilEffectiveDate, details.myYearlyMax);
          setValue(yearlyAmountName, amount);
          trigger(yearlyAmountName);
     }
     

    return ( 
          <>
          {enabled ?
          <>
          <div className='text-2xl text-danger mt-4 mb-2'>{title}</div>
          
           {planType === PlanType.DependentCareFsa ? 
               <div className='text-gray-500 mb-4'>*You should factor in contributions made during previous employment and by your spouse/domestic partner during 
                    {new Date(enrollments.effectiveDate).getFullYear()} while determining how much to contribute. Otherwise you could owe the IRS.
               </div> :
               <div className='mb-2'>&nbsp;</div>}
           

            <FormRadio name={coverageTypeName} label="What do you want to do?"  options={options} />
            
            {coverageType === 1 ? 
               <div className='ml-8'>
                    <div className='underline mb-2'>Weekly Paycheck Deduction: &nbsp;
                         <strong>
                              ${details.myWeeklyMax.toLocaleString()}
                         </strong>  
                         </div>
                   <ContributionInfo details={details} payPeriodsUntilEffectiveDate={payPeriodsUntilEffectiveDate} remainingPayChecksThisYear={remainingPayChecksThisYear} />
              </div> 
          : <>
          {coverageType === 2 ? 
               <div className='ml-8 grid md:grid-cols-2 max-w-screen-sm'>
                    <FormInput onChange={setWeekly} name={yearlyAmountName} label="Yearly Contribution Amount" type="currency" tooltipText={<ContributionInfo details={details} payPeriodsUntilEffectiveDate={payPeriodsUntilEffectiveDate} remainingPayChecksThisYear={remainingPayChecksThisYear} />} helperText={`Cannot exceed $${details.myYearlyMax.toLocaleString()} ${planType === PlanType.DependentCareFsa ? "per household" : ""} `} />
                    <FormInput onChange={setYearly} name={weeklyAmountName} label="Weekly Contribution Amount" type="currency" tooltipText={<ContributionInfo details={details} payPeriodsUntilEffectiveDate={payPeriodsUntilEffectiveDate} remainingPayChecksThisYear={remainingPayChecksThisYear} />} helperText={`Cannot exceed $${details.myWeeklyMax.toLocaleString()} `} />
               </div> :<></>
          
          }
          </>}
          </> :<></>}
          </>
     );
}
 
export default FsaDependent;